import { useApolloClient } from '@apollo/client';
import { SKILLS_SETTINGS_PATH } from 'pages/Settings/pages/Organization/SkillsPage/SkillsPage.constants';
import { SkillsPageEditView } from 'pages/Settings/pages/Organization/SkillsPage/SkillsPage.edit';
import { SkillsPageReadView } from 'pages/Settings/pages/Organization/SkillsPage/SkillsPage.read';
import { useOrganizationSkillsStore } from 'pages/Settings/pages/Organization/SkillsPage/store/organizationSkills.store';
import { FC, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { Route, Switch } from 'react-router-dom';
import isUserSecondarySelector from 'store/selectors/userSelectors/isUserSecondarySelector';
import { getCurrentlySelectedLocation } from 'utils/getCurrentlySelectedLocation';

export const SkillsPage: FC = () => {
  const apolloClient = useApolloClient();
  const isUserSecondary = useSelector(isUserSecondarySelector);
  const fetchSkills = useOrganizationSkillsStore((state) => state.fetchSkills);
  const locationId = Number(getCurrentlySelectedLocation()?.value);

  useEffect(() => {
    if (locationId > 0) return fetchSkills(apolloClient, locationId);
    return undefined;
  }, [apolloClient, fetchSkills, locationId]);

  if (isUserSecondary) return <SkillsPageReadView />;

  return (
    <Switch>
      <Route exact path={SKILLS_SETTINGS_PATH} component={SkillsPageReadView} />
      <Route exact path={`${SKILLS_SETTINGS_PATH}/edit`} component={SkillsPageEditView} />
    </Switch>
  );
};
